export default __webpack_public_path__ + "static/media/ethosLogo.ac77b56e.svg";